import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DictHandler } from 'src/app/types/@types/sl-v-types';
import { SLMap } from 'src/app/model/sl-map';

@Injectable({
	providedIn: 'root'
})
export class ModalLocationEntryService {
	public request$: Subject<any> = new Subject();
	constructor() { }

	RequestLocation(requestHandler: DictHandler, defaultType: string = 'search', slMap: SLMap) {
		return new Promise((resolve, error) => {
			resolve = null;
			error = null;
			this.request$.next({ handler: (requestHandler), type: defaultType, map: slMap });

		});
	}


}
